(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-search"]) return;
  try {
    
  document.querySelectorAll('.main-search-form').forEach((form) => {
    form.addEventListener('submit', () => {
      const searchInput = form.elements.namedItem('q');
      const searchTerm = searchInput.value.trim().replaceAll('"', '');

      if (searchTerm) {
        searchInput.value = `"${searchTerm}"`;
      }
    });
  });

  } catch(e) { console.error(e); }
})();
})();
